module.exports = __webpack_public_path__ + "static/media/rohithsajja-original.4c1360d0.png";